"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const request_1 = __importDefault(require("./request"));
const storable_result_1 = __importDefault(require("./storable_result"));
class MapboxProvider {
    constructor({ apiKey, locationType = "city", language, country }) {
        this.access_token = apiKey;
        this.locationType = locationType;
        this.language = language;
        this.country = country;
    }
    geocode(term) {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                limit: "10",
                autocomplete: "true",
                types: this.locationType,
                access_token: this.access_token,
            };
            this.addToOptions(options);
            const request = new request_1.default(options);
            return request.autocomplete(term);
        });
    }
    reverseGeocode(latitude, longitude) {
        return __awaiter(this, void 0, void 0, function* () {
            const term = [longitude, latitude].join(",");
            const options = {
                limit: "1",
                types: this.locationType,
                access_token: this.access_token,
            };
            this.addToOptions(options);
            const request = new request_1.default(options);
            const [result] = yield request.autocomplete(term);
            return result;
        });
    }
    resultSelected(result) {
        return __awaiter(this, void 0, void 0, function* () {
            // Due to MapBox's licensing terms, we need to hit the permanent
            // endpoint when getting a location that will be saved.
            const storableResult = new storable_result_1.default(result);
            return storableResult.call(this.access_token);
        });
    }
    addToOptions(options) {
        if (this.language) {
            options.language = this.joinParams(this.language);
        }
        if (this.country) {
            options.country = this.joinParams(this.country);
        }
    }
    joinParams(param) {
        if (Array.isArray(param)) {
            return param.join(",");
        }
        return param;
    }
}
exports.default = MapboxProvider;
